import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
function getLastThreeComponents(address) {
  if (!address) {
    return 'Location not available';
  }

  // Split the address into components and trim whitespace
  const components = address.split(',').map(component => component.trim());

  // Get the last three components
  const lastThree = components.slice(-3);

  // Join the components back into a string
  return lastThree.join(', ');
}

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig } = this.props;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';

    const fullAddress = publicData && publicData.location ? publicData.location.address : '';
    const simplifiedAddress = getLastThreeComponents(fullAddress); // Parse the address

    
    const city = publicData && publicData.location && publicData.location.city ? publicData.location.city : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
        {/* Display simplified address */}
        <div className={css.locationInfo}>
          <p>
          <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="#1B1F23" aria-hidden="true" viewBox="0 0 24 28">
          <path d="M12 0C7.58 0 4 3.58 4 8c0 3.8 4 9.45 6.8 12.8a1 1 0 0 0 1.4 0C16 17.45 20 11.8 20 8c0-4.42-3.58-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"></path>
          </svg>
          {simplifiedAddress}
          </p>
        </div>
      </section>
    );
  }
}

export default SectionMapMaybe;
